---
title: "Mission accomplished: 13 Monate Training – und mit 37 Jahren wieder ein Dunk!"
slug: "mission-accomplished-13-monate-training-dunk"
date: "2025-02-02"
excerpt: "Mission accomplished: 13 Monate Training – und mit 37 Jahren wieder ein Dunk! Gestern, beim Auswärtsspiel gegen die Heilbronn Reds, habe ich endlich das Ziel erreicht, das ich mir Anfang 2024 gesetzt hatte."
metaTitle: "Mission Accomplished: Mit 37 Jahren wieder ein Dunk | Kevin Rassner"
metaDescription: "Nach 13 Monaten Training: Mit 37 Jahren wieder dunken. Ein persönlicher Bericht über Zielsetzung, Training und den Erfolg beim Spiel gegen die Heilbronn Reds."
language: "de"
author: "Kevin Rassner"
authorUrl: "https://rassner-dev.org"
linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7291785920268161025"
isLinkedInPost: true
---

Mission accomplished: 13 Monate Training – und mit 37 Jahren wieder ein Dunk!

Gestern, beim Auswärtsspiel gegen die Heilbronn Reds, habe ich endlich das Ziel erreicht, das ich mir Anfang 2024 gesetzt hatte: wieder zu dunken. Ursprünglich war der 31.12. mein Stichtag, aber ein komplizierter Fingerbruch brachte eine sechswöchige Zwangspause. Also wurde es der 1.2. – aber es wurde!

Dunken war in meiner Jugend ein Teil meiner Identität. Doch mit den Jahren kamen andere Prioritäten: Familie, Job, Hausbau – und natürlich auch ein paar Kilos mehr. Trotzdem habe ich mir dieses Ziel gesetzt, weil es nicht nur eine Frage der Sprungkraft ist, sondern von Beweglichkeit, Geschwindigkeit, Gelenkgesundheit und einer Grundfitness, die das Training mit hohen Belastungen (z. B. Sprünge mit 80 kg Hantel) überhaupt erst ermöglicht, ohne zum Verletzungsrisiko zu werden.

Viele von euch wussten von diesem Vorhaben – ganz bewusst, weil ich wusste, dass mich dieser selbst erzeugte Peer Pressure am Ball bleiben lässt. Und genau deshalb geht es hier nicht um Management-Lehren oder Business-Metaphern, sondern schlicht um eine Danksagung:

An meine Arbeitskollegen, die mich immer wieder an mein Versprechen erinnert haben. An meine Teamkollegen, die mit mir trainiert und mich gepusht haben.

Ohne euch hätte ich es vermutlich nicht durchgezogen. Also: Danke! ❤️🏀

